module.exports = __webpack_public_path__ + "media/home/funnel-d15a5d17.png";